"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[555],{

/***/ 68219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ER": function() { return /* binding */ Summary; },
/* harmony export */   "H1": function() { return /* binding */ H1; },
/* harmony export */   "H2": function() { return /* binding */ H2; },
/* harmony export */   "H3": function() { return /* binding */ H3; },
/* harmony export */   "H4": function() { return /* binding */ H4; },
/* harmony export */   "HU": function() { return /* binding */ FooterText; },
/* harmony export */   "O": function() { return /* binding */ CardParagraph; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* unused harmony export FooterLink */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71383);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46133);


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;


var H1 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h1 */ .ZP.h1(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: 1.5rem;\n  text-align: ", ";\n  font-size: ", ";\n  @media screen and (max-width: ", ") {\n    font-size: ", ";\n  }\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.headingFontFamily;
}, function (_ref2) {
  var $textAlign = _ref2.$textAlign;
  return $textAlign ? $textAlign : 'initial';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.desktopFontSize.title;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.mobileFontSize.title;
}, function (_ref6) {
  var theme = _ref6.theme,
      $brand = _ref6.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
});
var H2 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h2 */ .ZP.h2(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: ", ";\n  font-size: ", ";\n  position: ", ";\n  left: ", ";\n  color: ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.headingFontFamily;
}, function (_ref8) {
  var $marginBottom = _ref8.$marginBottom;
  return $marginBottom || '1.5rem';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.typography.fontSizes[2];
}, function (_ref10) {
  var $sticky = _ref10.$sticky;
  return $sticky ? 'sticky' : 'initial';
}, function (_ref11) {
  var $sticky = _ref11.$sticky;
  return $sticky ? 0 : 'initial';
}, function (_ref12) {
  var theme = _ref12.theme,
      $brand = _ref12.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
});
var H3 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h3 */ .ZP.h3(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: initial;\n  color: ", ";\n  font-size: ", ";\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.headingFontFamily;
}, function (_ref14) {
  var $color = _ref14.$color;
  return $color ? $color : 'inherit';
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.typography.fontSizes[4];
});
var H4 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h4 */ .ZP.h4(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: ", ";\n  margin: initial;\n  margin-bottom: initial;\n  color: ", ";\n  font-size: ", ";\n\n  display: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  min-height: ", ";\n"])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.typography.headingFontFamily;
}, function (_ref17) {
  var $padding = _ref17.$padding;
  return $padding ? $padding : 'initial';
}, function (_ref18) {
  var theme = _ref18.theme,
      $brand = _ref18.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.typography.fontSizes[5];
}, function (_ref20) {
  var $ellipsis = _ref20.$ellipsis;
  return $ellipsis && '-webkit-box';
}, function (_ref21) {
  var $ellipsis = _ref21.$ellipsis;
  return $ellipsis && 2;
}, function (_ref22) {
  var $ellipsis = _ref22.$ellipsis;
  return $ellipsis && 'vertical';
}, function (_ref23) {
  var $ellipsis = _ref23.$ellipsis;
  return $ellipsis && 'hidden';
}, function (_ref24) {
  var $ellipsis = _ref24.$ellipsis;
  return $ellipsis && 'ellipsis';
}, function (_ref25) {
  var $ellipsis = _ref25.$ellipsis;
  return $ellipsis && '3.4rem';
});
var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p */ .ZP.p(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  text-align: ", ";\n  padding: ", ";\n  margin: initial;\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: calc(\n    ", " * 2\n  );\n  color: ", ";\n\n  display: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  min-height: ", ";\n"])), function (_ref26) {
  var theme = _ref26.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref27) {
  var $textAlign = _ref27.$textAlign;
  return $textAlign ? $textAlign : 'left';
}, function (_ref28) {
  var $padding = _ref28.$padding;
  return $padding ? $padding : '2rem 0';
}, function (_ref29) {
  var $fontWeight = _ref29.$fontWeight;
  return $fontWeight ? $fontWeight : 'initial';
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.typography.fontSizes[5];
}, function (_ref31) {
  var theme = _ref31.theme,
      $lineHeight = _ref31.$lineHeight;
  return $lineHeight ? $lineHeight : theme.typography.fontSizes[5];
}, function (_ref32) {
  var theme = _ref32.theme,
      $brand = _ref32.$brand,
      $color = _ref32.$color;
  return $brand ? theme.colors.primary : theme.colors[$color || 'text'];
}, function (_ref33) {
  var $ellipsis = _ref33.$ellipsis;
  return $ellipsis && '-webkit-box';
}, function (_ref34) {
  var $ellipsis = _ref34.$ellipsis;
  return $ellipsis && 4;
}, function (_ref35) {
  var $ellipsis = _ref35.$ellipsis;
  return $ellipsis && 'vertical';
}, function (_ref36) {
  var $ellipsis = _ref36.$ellipsis;
  return $ellipsis && 'hidden';
}, function (_ref37) {
  var $ellipsis = _ref37.$ellipsis;
  return $ellipsis && 'ellipsis';
}, function (_ref38) {
  var $ellipsis = _ref38.$ellipsis;
  return $ellipsis && '9.7rem';
});
var Summary = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject6 || (_templateObject6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  text-align: ", ";\n  max-width: 100vw;\n  overflow-wrap: break-word;\n  @media screen and (min-width: ", ") {\n    font-size: ", ";\n  }\n"])), function (_ref39) {
  var $textAlign = _ref39.$textAlign;
  return $textAlign ? $textAlign : 'center';
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.typography.fontSizes[3];
});
var CardParagraph = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p */ .ZP.p(_templateObject7 || (_templateObject7 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  font-size: ", ";\n  line-height: calc(", " * 1.25);\n  color: ", ";\n"])), function (_ref42) {
  var theme = _ref42.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.typography.fontSizes[5];
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.typography.fontSizes[5];
}, function (_ref45) {
  var $color = _ref45.$color,
      theme = _ref45.theme;
  return $color ? $color : theme.colors.text;
});
var FooterLink = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a */ .ZP.a(_templateObject8 || (_templateObject8 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (_ref46) {
  var theme = _ref46.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref47) {
  var theme = _ref47.theme,
      $brand = _ref47.$brand;
  return $brand ? theme.colors.linkColours.alt : theme.colors.text;
}, function (_ref48) {
  var theme = _ref48.theme,
      $brand = _ref48.$brand;
  return $brand ? theme.colors.linkColours.altHover : theme.colors.text;
});
var FooterText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject9 || (_templateObject9 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  text-align: center;\n  max-width: 800px;\n  line-height: 1.2;\n  a {\n    font-family: ", ";\n    color: ", ";\n  }\n"])), function (_ref49) {
  var theme = _ref49.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref50) {
  var theme = _ref50.theme;
  return theme.colors.primary;
});

/***/ }),

/***/ 55555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ table; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(46133);
;// CONCATENATED MODULE: ./components/atoms/Select.js


var _templateObject, _templateObject2;


var Select = styled_components_browser_esm/* default.select */.ZP.select(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: ", ";\n  background: ", ";\n  color: ", ";\n  cursor: pointer;\n  padding: 0.2rem 0.5rem;\n  min-height: 3.5rem;\n  height: 4rem;\n  -webkit-appearance: none;\n  border: none;\n\n  &:focus-visible {\n    outline: none;\n  }\n\n  > option {\n    background: ", ";\n    color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.glassSelectBackground;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.text;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.tableBackground;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.text;
});
var Option = styled_components_browser_esm/* default.option */.ZP.option(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-transform: capitalize;\n"])));
// EXTERNAL MODULE: ./node_modules/atomic-layout/lib/esm/index.js
var esm = __webpack_require__(19010);
;// CONCATENATED MODULE: ./components/atoms/Pagination.js


var Pagination_templateObject, Pagination_templateObject2, _templateObject3, _templateObject4, _templateObject5;



var PaginationWrapper = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(Pagination_templateObject || (Pagination_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: ", ";\n  left: ", ";\n  @media screen and (min-width: ", ") {\n    width: 100%;\n    margin: auto;\n  }\n"])), function (_ref) {
  var $sticky = _ref.$sticky;
  return $sticky ? 'sticky' : 'initial';
}, function (_ref2) {
  var $sticky = _ref2.$sticky;
  return $sticky ? 0 : 'initial';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.sm.maxWidth;
});
var Pagination = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(Pagination_templateObject2 || (Pagination_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem;\n  border-radius: ", ";\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  background: ", ";\n  width: 100%;\n  min-height: 4rem;\n  box-sizing: border-box;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return "0 0 ".concat(theme.glassEffect.borderRadius, " ").concat(theme.glassEffect.borderRadius);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.glassEffect.blur;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.glassEffect.blur;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.glassEffect.background;
});
var PaginationItem = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 2rem;\n"])));
var PageSelectContainer = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: ", ";\n  display: flex;\n  align-items: center;\n  border-radius: ", ";\n  color: ", ";\n  padding: 0rem 0;\n  min-height: 3.5rem;\n  border: none;\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.glassSelectBackground;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.text;
});
var TurnPage = styled_components_browser_esm/* default.button */.ZP.button(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border: none;\n  border-radius: ", ";\n  background: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n\n  svg {\n    height: 2rem;\n    width: 2rem;\n  }\n\n  g {\n    fill: ", ";\n  }\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref12) {
  var theme = _ref12.theme,
      disabled = _ref12.disabled;
  return disabled ? "".concat(theme.colors.text, "20") : theme.colors.text;
});
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
;// CONCATENATED MODULE: ./utils/csvExport.js

var encodeCSV = function encodeCSV(rows, columns) {
  return [columns.map(function (_ref) {
    var accessor = _ref.accessor,
        Header = _ref.Header;
    return "\"".concat(Header || accessor, "\"");
  }).join(",")].concat((0,toConsumableArray/* default */.Z)(rows.map(function (row) {
    return columns.map(function (_ref2) {
      var accessor = _ref2.accessor,
          Cell = _ref2.Cell;
      var value = row[accessor];
      if (Cell) return "\"".concat(Cell({
        value: value
      }), "\"");else return "\"".concat(value, "\"");
    }).join(",");
  }))).join("\n");
};
var downloadCSV = function downloadCSV(csvContent) {
  var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "SatsGoal_Data.csv";
  var encodedUri = encodeURI("data:text/csv;charset=utf-8,".concat(csvContent));
  var link = document.createElement("a");
  link.style.display = 'none';
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
};
// EXTERNAL MODULE: ./node_modules/react-table/index.js
var react_table = __webpack_require__(79521);
// EXTERNAL MODULE: ./components/atoms/Buttons.js
var Buttons = __webpack_require__(87314);
// EXTERNAL MODULE: ./components/atoms/Text.js
var Text = __webpack_require__(68219);
// EXTERNAL MODULE: ./utils/utils.js
var utils = __webpack_require__(91851);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/table.js



var table_templateObject, table_templateObject2, table_templateObject3, table_templateObject4, table_templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









/* eslint-disable react/jsx-key */




var TableContainer = styled_components_browser_esm/* default.div */.ZP.div(table_templateObject || (table_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: auto;\n  width: 100%;\n  border-radius: ", ";\n  border-bottom: ", ";\n  background-color: ", ";\n  overflow-x: scroll;\n  @media screen and (min-width: ", ") {\n    overflow-x: hidden;\n    overflow-y: ", ";\n  }\n\n  ::-webkit-scrollbar {\n    width: 5px;\n    height: 15px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: #a3a3a3;\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    background: #868686;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.glassEffect.tableBorderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "0.2rem solid ".concat(theme.colors.text);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.glassBackground;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.sm.minWidth;
}, function (_ref5) {
  var $hide = _ref5.$hide;
  return $hide ? 'hidden' : 'scroll';
});
var STable = styled_components_browser_esm/* default.table */.ZP.table(table_templateObject2 || (table_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-align: left;\n  position: relative;\n  border-collapse: collapse;\n  width: 100%;\n  height: 100%;\n"])));
var THead = styled_components_browser_esm/* default.thead */.ZP.thead(table_templateObject3 || (table_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n"])));
var TBody = styled_components_browser_esm/* default.tbody */.ZP.tbody(table_templateObject4 || (table_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var TH = styled_components_browser_esm/* default.th */.ZP.th(table_templateObject5 || (table_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 1.4rem;\n  min-width: 10rem;\n  max-width: 15rem;\n  background-color: ", ";\n  color: ", ";\n  position: ", ";\n  left: ", ";\n  z-index: ", ";\n\n  &:first-of-type {\n    border-radius-top-left: 0.5rem;\n    -webkit-border-top-left-radius: 0.5rem;\n  }\n\n  &:last-of-type {\n    border-radius-top-right: 0.5rem;\n    -webkit-border-top-right-radius: 0.5rem;\n  }\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.tableHead;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.text;
}, function (_ref8) {
  var $sticky = _ref8.$sticky;
  return $sticky ? 'sticky' : 'initial';
}, function (_ref9) {
  var $sticky = _ref9.$sticky;
  return $sticky ? 0 : 'initial';
}, function (_ref10) {
  var $sticky = _ref10.$sticky;
  return $sticky ? 25 : 'initial';
});
var TR = styled_components_browser_esm/* default.tr */.ZP.tr(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: ", ";\n  top: ", ";\n  z-index: ", ";\n  border-bottom: thin solid rgba(255, 255, 255, 0.05);\n  vertical-align: ", ";\n"])), function (_ref11) {
  var $sticky = _ref11.$sticky;
  return $sticky ? 'sticky' : 'initial';
}, function (_ref12) {
  var $sticky = _ref12.$sticky;
  return $sticky ? 0 : 'initial';
}, function (_ref13) {
  var $sticky = _ref13.$sticky;
  return $sticky ? 20 : 'initial';
}, function (_ref14) {
  var $headerRow = _ref14.$headerRow;
  return $headerRow ? 'bottom' : 'initial';
});
var TD = styled_components_browser_esm/* default.td */.ZP.td(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 5px;\n    padding-left: 1rem\n    color: ", ";\n    background-color: ", ";\n    position: ", ";\n    left: ", ";\n    z-index: ", ";\n"])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.text;
}, function (_ref16) {
  var $sticky = _ref16.$sticky,
      theme = _ref16.theme;
  return $sticky ? theme.colors.tableBackground : 'inherit';
}, function (_ref17) {
  var $sticky = _ref17.$sticky;
  return $sticky ? 'sticky' : 'initial';
}, function (_ref18) {
  var $sticky = _ref18.$sticky;
  return $sticky ? 0 : 'initial';
}, function (_ref19) {
  var $sticky = _ref19.$sticky;
  return $sticky ? 10 : 'initial';
});
var BorderBottom = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 1px;\n  width: 100%;\n  background: ", ";\n  z-index: ", ";\n"])), function (_ref20) {
  var $color = _ref20.$color,
      theme = _ref20.theme;
  return $color ? theme.colors[$color] : 'transparent';
}, function (_ref21) {
  var $sticky = _ref21.$sticky;
  return $sticky ? 25 : 'initial';
});
var THInner = styled_components_browser_esm/* default.div */.ZP.div(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background: ", ";\n"])), function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.glassBackground;
});
var THInnerTextWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 1;\n  padding-left: 1rem !important;\n  padding: 0.5rem;\n"])));
var FullTable = styled_components_browser_esm/* default.div */.ZP.div(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n  box-shadow: ", ";\n"])), function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.shadow;
});
var PAGE_SIZE = 12;

var Table = function Table(_ref24) {
  var data = _ref24.data,
      columns = _ref24.columns,
      stackingFrequency = _ref24.stackingFrequency,
      displayFrequency = _ref24.displayFrequency,
      setDisplayFrequency = _ref24.setDisplayFrequency;
  var tableInstance = (0,react_table.useTable)({
    data: data,
    columns: columns,
    initialState: {
      pageIndex: 0,
      pageSize: PAGE_SIZE
    }
  }, react_table.useSortBy, react_table.usePagination);
  var getTableProps = tableInstance.getTableProps,
      getTableBodyProps = tableInstance.getTableBodyProps,
      headerGroups = tableInstance.headerGroups,
      page = tableInstance.page,
      prepareRow = tableInstance.prepareRow,
      canPreviousPage = tableInstance.canPreviousPage,
      canNextPage = tableInstance.canNextPage,
      nextPage = tableInstance.nextPage,
      previousPage = tableInstance.previousPage,
      setPageSize = tableInstance.setPageSize,
      _tableInstance$state = tableInstance.state,
      pageIndex = _tableInstance$state.pageIndex,
      pageSize = _tableInstance$state.pageSize;
  var numberPagesArray = [PAGE_SIZE, 50, 100].filter(function (size) {
    if (size <= data.length) return true;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FullTable, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TableContainer, {
      style: {
        overflow: 'auto',
        height: data.length >= 12 ? 'calc(100% - 50px)' : 'auto'
      },
      $hide: pageSize && pageSize <= PAGE_SIZE,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(STable, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(THead, {
          children: headerGroups.map(function (headerGroup) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(TR, _objectSpread(_objectSpread({}, headerGroup.getHeaderGroupProps()), {}, {
              $sticky: true,
              $headerRow: true,
              children: headerGroup.headers.map(function (column) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(TH, _objectSpread(_objectSpread({}, column.getHeaderProps(column.getSortByToggleProps())), {}, {
                  $sticky: column.sticky,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(THInner, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(THInnerTextWrapper, {
                      children: [column.render('Header'), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: column.isSorted ? column.isSortedDesc ? /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* RiArrowDropUpFill */.bOz, {
                          height: "17px",
                          width: "17px",
                          alt: "Sort Desc"
                        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* RiArrowDropDownFill */.mEq, {
                          height: "17px",
                          width: "17px",
                          alt: "Sort Asc"
                        }) : ''
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BorderBottom, {
                      $color: column.color,
                      $sticky: column.sticky
                    })]
                  })
                }));
              })
            }));
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TBody, _objectSpread(_objectSpread({}, getTableBodyProps()), {}, {
          children: page.map(function (row, i) {
            prepareRow(row);
            return /*#__PURE__*/(0,jsx_runtime.jsx)(TR, _objectSpread(_objectSpread({}, row.getRowProps()), {}, {
              children: row.cells.map(function (cell) {
                var sticky = cell.column.sticky;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(TD, _objectSpread(_objectSpread({
                  $sticky: sticky
                }, cell.getCellProps()), {}, {
                  children: cell.render('Cell')
                }));
              })
            }));
          })
        }))]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationWrapper, {
      flex: true,
      $sticky: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Pagination, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PaginationItem, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Select, {
            value: displayFrequency,
            onChange: function onChange(e) {
              setDisplayFrequency(e.target.value);
            },
            children: ['DAILY', 'WEEKLY', 'MONTHLY', 'YEARLY'].filter(function (item, idx, array) {
              if (idx >= array.indexOf(stackingFrequency)) return true;else return false;
            }).map(function (freq) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Option, {
                value: freq,
                children: (0,utils/* sentenceCase */.G8)(freq.replace(/ly/gi, '').replace(/i$/gi, 'y'))
              }, freq);
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* Button */.zx, {
            onClick: function onClick() {
              var csvContent = encodeCSV(data, columns);
              downloadCSV(csvContent);
            },
            children: "Export to CSV"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PaginationItem, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Select, {
            value: pageSize,
            onChange: function onChange(e) {
              setPageSize(Number(e.target.value));
            },
            children: [numberPagesArray.map(function (pageSize) {
              var display = pageSize;
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(Option, {
                value: pageSize,
                children: ["Show ", display]
              }, pageSize);
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Option, {
              value: data.length,
              children: "Show All"
            }, "All")]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PageSelectContainer, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TurnPage, {
              onClick: previousPage,
              disabled: !canPreviousPage,
              "aria-label": "Previous Page",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* RiArrowLeftSLine */.jW7, {})
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Paragraph */.nv, {
              $padding: "initial",
              children: pageIndex + 1
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TurnPage, {
              onClick: nextPage,
              disabled: !canNextPage,
              "aria-label": "Next Page",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* RiArrowRightSLine */.jfD, {})
            })]
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var table = (Table);

/***/ })

}]);